import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    // state: {
    //     user: JSON.parse(localStorage.getItem('user')) || ''
    // },
    // getters: {
    //     user: state => state.user
    // },
    // mutations: {
    //     setUser(state, user) {
    //         state.user = user
    //     }
    // },
    // actions: {
    //     setUser({
    //         commit
    //     }, user) {
    //         commit('setUser', user)
    //         localStorage.setItem('user', JSON.stringify(user));
    //     }
    // },
    // modules: {},
});